import { buildSubscriptionHref } from 'Pods/ThreeDStudio/Components/UsageModal/constants'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

export function useSubscriptionHref() {
  const subscriptionPaymentFormUrl = useThreeDStudioStore(
    state => state.subscription.subscriptionPaymentFormUrl
  )
  return buildSubscriptionHref(subscriptionPaymentFormUrl)
}
